import { render } from "./WalletAnnoucement.vue?vue&type=template&id=3a04592c"
import script from "./WalletAnnoucement.vue?vue&type=script&lang=js"
export * from "./WalletAnnoucement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__